__turbopack_context__.v({
  "empty-option": "WresOa_empty-option",
  "error-message": "WresOa_error-message",
  "footer": "WresOa_footer",
  "label": "WresOa_label",
  "label-disabled": "WresOa_label-disabled",
  "select": "WresOa_select",
  "wrapper": "WresOa_wrapper",
});
